export function showBanner() {
  const button = document.getElementById('js-showBanner');
  const trigger = document.getElementById('js-showBannerTrriger');
  if (!(button || trigger)) return;

  const hideButton = (nav) => {
    nav.classList.remove('_show');
  };
  const showButton = (nav) => {
    nav.classList.add('_show');
  };

  const observerFunction = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        hideButton(button);
      } else {
        showButton(button);
      }
    });
  };

  const observerTrigger = new IntersectionObserver(observerFunction, {
    root: null,
    rootMargin: '-99% 0px -1% 0px',
    threshold: 0,
  });

  const executeObserver = (observer) => {
    observer.observe(trigger);
  };

  executeObserver(observerTrigger);
}
